import React, { useEffect } from "react";
import styled from "styled-components";

import ChannelTalk from "../../Model/Share/Network/ChannelTalk";
import KeypadView from "../../Model/Individual/KeypadModel/KeypadView";

export default function KeypadForAttendancePage() {
  // Chrome 오버스크롤 시 body 흰 배경 노출 방지 //
  useEffect(() => {
    const prevBg = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#0A0A0A';
    return () => { document.body.style.backgroundColor = prevBg; };
  }, []);

  // 키패드 페이지 진입 시 채널톡 숨김 //
  useEffect(() => {
    ChannelTalk.shutdown();
    return () => {
      ChannelTalk.boot({ "pluginKey": "d2f4dfce-95e8-498e-aed3-84804b9d3772" });
    };
  }, []);

  return (
    <TopLevelWrapper>
      <KeypadView/>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100vw;
  min-height: 100svh;

  overflow: hidden;
`;
